module.exports = __webpack_public_path__ + "media/images/hitfun/logo-25e04605d75e860bd21bcb462ea8c76b.svg";